import { isEqual } from './javascript'
import userIcon from '../assets/icons/user.svg'
import mart1 from '../assets/user/mart-1.png'
import user1 from '../assets/user/user-1.png'
import user2 from '../assets/user/user-2.png'
import user3 from '../assets/user/user-3.png'
import user4 from '../assets/user/user-4.png'
import user5 from '../assets/user/user-5.png'
import user6 from '../assets/user/user-6.png'
import user7 from '../assets/user/user-7.png'
import user8 from '../assets/user/user-8.png'
import vendor1 from '../assets/user/vendor-1.png'
import vendor2 from '../assets/user/vendor-2.png'
import vendor3 from '../assets/user/vendor-3.png'
import vendor4 from '../assets/user/vendor-4.png'
export const LOGOUT = 'LOGOUT'

const userWiseRole = {
  admin: 1,
  storeOwner: 2,
  store: 3,
  storeManager: 4,
  storeEmployee: 5,
  vendor: 6,
  manufacturer: 7,
  customer: 8,
}

const {
  admin,
  storeOwner,
  store,
  storeManager,
  storeEmployee,
  vendor,
  manufacturer,
  customer,
} = userWiseRole

const childUsers = []

const userDataList = ({ roleId }) => {
  switch (roleId) {
    case admin:
      return {
        list: [
          {
            id: 1,
            roleId: admin,
            profileUrl: userIcon,
            lastName: 'Genba_Admin',
            emailId: 'genba.admin@gmail.com',
            phoneNumber: '123456789',
            address: '123-45th St.678',
            city: 'Noida',
            state: 'Uttar Pradesh',
            country: 'in',
            pincode: 201305,
            creationDate: 1683708390593,
            modificationDate: 0,
            adminId: 94,
            inchargeDepartment: null,
            inchargePerson: null,
            parent: { id: 376 },
          },
        ],
      }
    case storeOwner:
      return {
        list: [
          {
            id: 1,
            roleId: storeOwner,
            profileUrl: user1,
            lastName: 'Suneetha Sagar',
            emailId: 'suneetha@gmail.com',
            phoneNumber: '123456789',
            address: '123-45th St.678',
            city: 'Noida',
            state: 'Uttar Pradesh',
            country: 'in',
            pincode: 201305,
            creationDate: 1683708390593,
            modificationDate: 0,
            adminId: 94,
            inchargeDepartment: null,
            inchargePerson: null,
            parent: { id: 376 },
          },
          {
            id: 2,
            roleId: storeOwner,
            profileUrl: user2,
            lastName: 'John Prabudoss',
            emailId: 'john.john@gmail.com',
            phoneNumber: '123456789',
            address: '123-45th St.678',
            city: 'Bangalore',
            state: 'Karnataka',
            country: 'in',
            pincode: 560001,
            creationDate: 1683718390593,
            modificationDate: 0,
            adminId: 95,
            inchargeDepartment: 'Sales',
            inchargePerson: 'John Doe',
            parent: { id: 377 },
          },
          {
            id: 3,
            roleId: storeOwner,
            profileUrl: user8,
            lastName: 'Rachell Johnson',
            emailId: 'rachell.johnson@gmail.com',
            phoneNumber: '123456789',
            address: '123-45th St.678',
            city: 'Mumbai',
            state: 'Maharashtra',
            country: 'in',
            pincode: 400059,
            creationDate: 1683728390593,
            modificationDate: 0,
            adminId: 96,
            inchargeDepartment: 'Marketing',
            inchargePerson: 'Jane Smith',
            parent: { id: 378 },
          },
        ],
      }
    case store:
      return {
        list: [
          {
            id: 1,
            roleId: store,
            profileUrl: mart1,
            businessName: 'John Mart 1',
            inchargeName: 'Suneetha Sagar',
            lastName: 'John Mart 1',
            emailId: 'suneetha@gmail.com',
            phoneNumber: '1234567890',
            address: '101 Main Avenue, Connaught Place',
            city: 'Delhi',
            state: 'Delhi',
            country: 'in',
            pincode: 110001,
            creationDate: 1683708390593,
            modificationDate: 0,
            adminId: 401,
            parent: {},
          },
          {
            id: 2,
            roleId: store,
            profileUrl: mart1,
            businessName: 'John Mart 2',
            inchargeName: 'Suneetha Sagar',
            lastName: 'John Mart 2',
            emailId: 'suneetha@gmail.com',
            phoneNumber: '9876541230',
            address: '500 MG Road, Block A',
            city: 'Bangalore',
            state: 'Karnataka',
            country: 'in',
            pincode: 560001,
            creationDate: 1683718390593,
            modificationDate: 0,
            adminId: 402,
            parent: {},
          },
          {
            id: 3,
            roleId: store,
            profileUrl: mart1,
            businessName: 'John Mart 3',
            inchargeName: 'Suneetha Sagar',
            lastName: 'John Mart 3',
            emailId: 'suneetha@gmail.com',
            phoneNumber: '9123456780',
            address: '12 Marine Drive, Block C',
            city: 'Mumbai',
            state: 'Maharashtra',
            country: 'in',
            pincode: 400020,
            creationDate: 1683728390593,
            modificationDate: 0,
            adminId: 403,
            parent: {},
          },
          {
            id: 4,
            roleId: store,
            profileUrl: mart1,
            businessName: 'John Mart 4',
            inchargeName: 'Suneetha Sagar',
            lastName: 'John Mart 4',
            emailId: 'suneetha@gmail.com',
            phoneNumber: '9012345678',
            address: '100 Salt Lake, Sector 5',
            city: 'Kolkata',
            state: 'West Bengal',
            country: 'in',
            pincode: 700091,
            creationDate: 1683738390593,
            modificationDate: 0,
            adminId: 404,
            parent: {},
          },
        ],
      }
    case storeManager:
      return {
        list: [
          {
            id: 1,
            roleId: storeManager,
            profileUrl: user3,
            businessName: 'John Mart 1',
            firstName: 'Rahul',
            lastName: 'Rahul Singh',
            level: 'Manager',
            emailId: 'lorem@gmail.com',
            phoneNumber: '9876543210',
            address: '123-45th St.678',
            city: 'Noida',
            state: 'Uttar Pradesh',
            country: 'in',
            pincode: 201305,
            creationDate: 1683708390593,
            modificationDate: 0,
            adminId: 101,
            inchargeDepartment: 'Management',
            inchargePerson: 'John Prabudoss',
            parent: {},
          },
          {
            id: 2,
            roleId: storeManager,
            profileUrl: user4,
            businessName: 'John Mart 1',
            firstName: 'Aman',
            lastName: 'Aman Kumar',
            level: 'Manager',
            emailId: 'lorem@gmail.com',
            phoneNumber: '9123456789',
            address: '456-78th St.789',
            city: 'Bangalore',
            state: 'Karnataka',
            country: 'in',
            pincode: 560001,
            creationDate: 1683718390593,
            modificationDate: 0,
            adminId: 102,
            inchargeDepartment: 'Sales',
            inchargePerson: 'Rachell Johnson',
            parent: {},
          },
          {
            id: 3,
            roleId: storeManager,
            profileUrl: user5,
            businessName: 'John Mart 2',
            firstName: 'Jessica',
            lastName: 'Jessica Long',
            level: 'Manager',
            emailId: 'lorem@gmail.com',
            phoneNumber: '9034567890',
            address: '789-01th St.101',
            city: 'Mumbai',
            state: 'Maharashtra',
            country: 'in',
            pincode: 400059,
            creationDate: 1683728390593,
            modificationDate: 0,
            adminId: 103,
            inchargeDepartment: 'Operations',
            inchargePerson: 'Steven Clarke',
            parent: {},
          },
          {
            id: 4,
            roleId: storeManager,
            profileUrl: user6,
            businessName: 'John Mart 2',
            firstName: 'Sam',
            lastName: 'Sam Smith',
            level: 'Manager',
            emailId: 'lorem@gmail.com',
            phoneNumber: '9988776655',
            address: '102-23th St.567',
            city: 'Chennai',
            state: 'Tamil Nadu',
            country: 'in',
            pincode: 600001,
            creationDate: 1683738390593,
            modificationDate: 0,
            adminId: 104,
            inchargeDepartment: 'Customer Service',
            inchargePerson: 'Anna White',
            parent: {},
          },
        ],
      }
    case storeEmployee:
      return {
        list: [
          {
            id: 1,
            roleId: storeEmployee,
            profileUrl: user3,
            businessName: 'John Mart 1',
            firstName: 'Rahul',
            lastName: 'Rahul Singh',
            level: 'Leader',
            emailId: 'lorem@gmail.com',
            phoneNumber: '9876543210',
            address: '123-45th St.678',
            city: 'Noida',
            state: 'Uttar Pradesh',
            country: 'in',
            pincode: 201305,
            creationDate: 1683708390593,
            modificationDate: 0,
            adminId: 101,
            inchargeDepartment: 'Management',
            inchargePerson: 'John Prabudoss',
            parent: {},
          },
          {
            id: 2,
            roleId: storeEmployee,
            profileUrl: user4,
            businessName: 'John Mart 1',
            firstName: 'Aman',
            lastName: 'Aman Kumar',
            level: 'Regular',
            emailId: 'lorem@gmail.com',
            phoneNumber: '9123456789',
            address: '456-78th St.789',
            city: 'Bangalore',
            state: 'Karnataka',
            country: 'in',
            pincode: 560001,
            creationDate: 1683718390593,
            modificationDate: 0,
            adminId: 102,
            inchargeDepartment: 'Sales',
            inchargePerson: 'Rachell Johnson',
            parent: {},
          },
          {
            id: 3,
            roleId: storeEmployee,
            profileUrl: user5,
            businessName: 'John Mart 2',
            firstName: 'Jessica',
            lastName: 'Jessica Long',
            level: 'Leader',
            emailId: 'lorem@gmail.com',
            phoneNumber: '9034567890',
            address: '789-01th St.101',
            city: 'Mumbai',
            state: 'Maharashtra',
            country: 'in',
            pincode: 400059,
            creationDate: 1683728390593,
            modificationDate: 0,
            adminId: 103,
            inchargeDepartment: 'Operations',
            inchargePerson: 'Steven Clarke',
            parent: {},
          },
          {
            id: 4,
            roleId: storeEmployee,
            profileUrl: user6,
            businessName: 'John Mart 2',
            firstName: 'Sam',
            lastName: 'Sam Smith',
            level: 'Regular',
            emailId: 'lorem@gmail.com',
            phoneNumber: '9988776655',
            address: '102-23th St.567',
            city: 'Chennai',
            state: 'Tamil Nadu',
            country: 'in',
            pincode: 600001,
            creationDate: 1683738390593,
            modificationDate: 0,
            adminId: 104,
            inchargeDepartment: 'Customer Service',
            inchargePerson: 'Anna White',
            parent: {},
          },
          {
            id: 5,
            roleId: storeEmployee,
            profileUrl: user7,
            businessName: 'John Mart 3',
            firstName: '',
            lastName: 'George',
            level: 'Leader',
            emailId: 'lorem@gmail.com',
            phoneNumber: '9988776655',
            address: '102-23th St.567',
            city: 'Chennai',
            state: 'Tamil Nadu',
            country: 'in',
            pincode: 600001,
            creationDate: 1683738390593,
            modificationDate: 0,
            adminId: 104,
            inchargeDepartment: 'Customer Service',
            inchargePerson: 'Anna White',
            parent: {},
          },
          {
            id: 6,
            roleId: storeEmployee,
            profileUrl: user8,
            businessName: 'John Mart 3',
            firstName: '',
            lastName: 'Steven',
            level: 'Leader',
            emailId: 'lorem@gmail.com',
            phoneNumber: '9988776655',
            address: '102-23th St.567',
            city: 'Chennai',
            state: 'Tamil Nadu',
            country: 'in',
            pincode: 600001,
            creationDate: 1683738390593,
            modificationDate: 0,
            adminId: 104,
            inchargeDepartment: 'Customer Service',
            inchargePerson: 'Anna White',
            parent: {},
          },
        ],
      }
    case vendor:
      return {
        list: [
          {
            id: 1,
            roleId: vendor,
            profileUrl: vendor1,
            businessName: 'Sunrise',
            lastName: '',
            inchargeName: 'Jignesh Patel',
            emailId: 'jignesh.patel@sunrise.com',
            phoneNumber: '9876543210',
            address: '456-78th Avenue, Block B',
            city: 'Noida',
            state: 'Uttar Pradesh',
            country: 'in',
            pincode: 201309,
            creationDate: 1683708390593,
            modificationDate: 0,
            adminId: 101,
            parent: {},
          },
          {
            id: 2,
            roleId: vendor,
            profileUrl: vendor2,
            businessName: 'SK Suppliers',
            lastName: '',
            inchargeName: 'SK Shah',
            emailId: 'sk.shah@sk-suppliers.com',
            phoneNumber: '9123456789',
            address: '789 Main Street, Building 4, Tech Park',
            city: 'Bangalore',
            state: 'Karnataka',
            country: 'in',
            pincode: 560002,
            creationDate: 1683718390593,
            modificationDate: 0,
            adminId: 102,
            parent: {},
          },
          {
            id: 3,
            roleId: vendor,
            profileUrl: vendor3,
            businessName: 'Lorem Ipsum',
            lastName: '',
            inchargeName: 'Jake Usan',
            emailId: 'jake.usan@loremipsum.com',
            phoneNumber: '8234567890',
            address: '321 First Avenue, Block C, Industrial Area',
            city: 'Mumbai',
            state: 'Maharashtra',
            country: 'in',
            pincode: 400060,
            creationDate: 1683728390593,
            modificationDate: 0,
            adminId: 103,
            parent: {},
          },
          {
            id: 4,
            roleId: vendor,
            profileUrl: vendor4,
            businessName: 'Techno Goods',
            lastName: '',
            inchargeName: 'Smith Lee',
            emailId: 'smith.lee@technogoods.com',
            phoneNumber: '9345678901',
            address: '102 Tech Lane, Industrial District, Block D',
            city: 'Chennai',
            state: 'Tamil Nadu',
            country: 'in',
            pincode: 600002,
            creationDate: 1683738390593,
            modificationDate: 0,
            adminId: 104,
            parent: {},
          },
        ],
      }
    case manufacturer:
      return {
        list: [
          {
            id: 1,
            roleId: manufacturer,
            profileUrl: vendor1,
            businessName: 'Virginia Lottery',
            firmName: '',
            lastName: '',
            inchargeName: 'Jignesh Patel',
            emailId: 'lorem.ipsum@gmail.com',
            phoneNumber: '9988776655',
            address: '102 Finance Tower, Level 3',
            city: 'Mumbai',
            state: 'Maharashtra',
            country: 'in',
            pincode: 400021,
            creationDate: 1683708390593,
            modificationDate: 0,
            adminId: 501,
            parent: {},
          },
        ],
      }
    case customer:
      return {
        list: [
          {
            id: 1,
            roleId: customer,
            profileUrl: userIcon,
            lastName: 'Ankit Sharma',
            emailId: 'ankit.sharma@gmail.com',
            phoneNumber: '9988776655',
            address: '123 Green Lane, Apartment 5A',
            city: 'Pune',
            state: 'Maharashtra',
            country: 'in',
            pincode: 411001,
            creationDate: 1683708390593,
            modificationDate: 0,
            adminId: 201,
            parent: {},
          },
          {
            id: 2,
            roleId: customer,
            profileUrl: userIcon,
            lastName: 'Priya Das',
            emailId: 'priya.das@example.com',
            phoneNumber: '9876541230',
            address: '456 Sunset Boulevard, Villa 10',
            city: 'Kolkata',
            state: 'West Bengal',
            country: 'in',
            pincode: 700019,
            creationDate: 1683718390593,
            modificationDate: 0,
            adminId: 202,
            parent: {},
          },
          {
            id: 3,
            roleId: customer,
            profileUrl: userIcon,
            lastName: 'Arjun Verma',
            emailId: 'arjun.verma@example.com',
            phoneNumber: '9123456780',
            address: '32 Elm Street, Block B',
            city: 'Hyderabad',
            state: 'Telangana',
            country: 'in',
            pincode: 500081,
            creationDate: 1683728390593,
            modificationDate: 0,
            adminId: 203,
            parent: {},
          },
          {
            id: 4,
            roleId: customer,
            profileUrl: userIcon,
            lastName: 'Nisha Kaur',
            emailId: 'nisha.kaur@samplemail.com',
            phoneNumber: '9012345678',
            address: '78 Maple Avenue, Floor 3',
            city: 'Chandigarh',
            state: 'Punjab',
            country: 'in',
            pincode: 160017,
            creationDate: 1683738390593,
            modificationDate: 0,
            adminId: 204,
            parent: {},
          },
          {
            id: 5,
            roleId: customer,
            profileUrl: userIcon,
            lastName: 'Rohit Kulkarni',
            emailId: 'rohit.kulkarni@gmail.com',
            phoneNumber: '8901234567',
            address: '15 Pine Street, Villa B-1',
            city: 'Ahmedabad',
            state: 'Gujarat',
            country: 'in',
            pincode: 380015,
            creationDate: 1683748390593,
            modificationDate: 0,
            adminId: 205,
            parent: {},
          },
        ],
      }
    default:
      return { list: [] }
  }
}

const getDummyUser = ({ roleId, userId }) => {
  const userList = userDataList({ roleId })?.list
  return userList?.find(user => isEqual(user?.id, userId)) || userList?.[0]
}

export { childUsers, userDataList, userWiseRole, getDummyUser }
